import { assignmentA1, assignmentA2, assignmentA3, assignmentA4, assignmentA5, assignmentU1, assignmentU2, daysOfTheWeekS, generalHelpers } from '@monorepo/helpers';
import { BsTrashFill } from 'react-icons/bs';
import { Dispatch, FC, SetStateAction } from 'react';
import { typeMeeting, typeUser, typeUserAssigned } from '@monorepo/models';
import { useGetIsDarkMode } from 'src/custom-hooks';
import Select from 'react-select';

type propsType = {
    hideWeekNumber?: boolean;
    isEdit: boolean;
    meetings: typeMeeting[];
    setMeetingsToSave: Dispatch<SetStateAction<typeMeeting[] | null>>;
    users: typeUser[];
};

export const AVUshersTable: FC<propsType> = ({ hideWeekNumber, isEdit, meetings, setMeetingsToSave, users }) => {
    const isDarkMode = useGetIsDarkMode();

    const getClasses = (i: number, meeting?: typeMeeting, user?: typeUserAssigned | null): string => {
        if (!!meeting && !!user && [...meeting.avAssignments, ...meeting.usherAssignments].filter(a => a.user?.id === user.id).length > 1) {
            return 'bg-danger text-white';
        }
        let classes = meeting && user ? 'select-with-user ' : '';
        if (isDarkMode) {
            if (i % 2) {
                classes += 'text-white';
            } else {
                classes += 'bg-lightdark text-white';
            }
        } else {
            if (i % 2) {
                classes += 'bg-striped';
            } else {
                classes += '';
            }
        }
        return classes;
    }

    return (
        <div className={'table-responsive mt-3'}>
            <style>
                {'.css-1nmdiq5-menu {min-width: 300px;}'}
                {'.select-with-user .css-13cymwt-control {background-color: #adb5bd !important;}'}
            </style>
            <table className={`table table-bordered ${isDarkMode ? 'table-dark' : ''} small font-monospace w-100 mx-auto`}>
                <thead>
                    <tr>
                        <th colSpan={isEdit ? 1 : 2} className={isDarkMode ? '' : 'bg-striped'}>Fecha</th>
                        {!hideWeekNumber &&
                            <>
                            <th className={isDarkMode ? '' : 'bg-striped'}>Sem</th>
                            <th className={isDarkMode ? '' : 'bg-striped'}>Año</th>
                            </>
                        }
                        <th className={isDarkMode ? '' : 'bg-striped'}>Consola</th>
                        <th className={isDarkMode ? '' : 'bg-striped'}>Zoom</th>
                        <th className={isDarkMode ? '' : 'bg-striped'}>Mic. 1</th>
                        <th className={isDarkMode ? '' : 'bg-striped'}>Mic. 2</th>
                        <th className={isDarkMode ? '' : 'bg-striped'}>Plataforma</th>
                        <th className={isDarkMode ? '' : 'bg-striped'}>Acomod. Entrada</th>
                        <th className={isDarkMode ? '' : 'bg-striped'}>Acomod. Auditorio</th>
                        {isEdit &&
                            <th className={isDarkMode ? '' : 'bg-light'}>Eliminar</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    {meetings.map((m, i) =>
                        <tr key={m.id}>
                            <td className={`${getClasses(i)} text-nowrap`}>
                                {isEdit ?
                                    <input type={'date'}
                                        className={'form-control form-control-sm'}
                                        value={m.date}
                                        // onChange={e => {
                                        //     const v = e.target.value;
                                        //     const _year = parseInt(v.split('-')[0]);
                                        //     const date = generalHelpers.GetDateFromDateString(v);
                                        //     setMeetingsToSave(x => x!.map(_m => _m.id === m.id ? ({
                                        //         ..._m,
                                        //         date: v,
                                        //         weekday: date.getDay(),
                                        //         weekNumber: generalHelpers.GetCalendarWeekNumber(date),
                                        //         year: _year
                                        //     }) : _m));
                                        // }}
                                        // disabled={!!m.sections.length}
                                        disabled
                                    />
                                    :
                                    <>{daysOfTheWeekS[m.weekday]}</>
                                }
                            </td>
                            {!isEdit &&
                                <td className={'text-nowrap text-start'}>
                                    {generalHelpers.InvertDateString(m.date)}
                                </td>
                            }
                            {!hideWeekNumber &&
                                <>
                                <td className={getClasses(i)}>
                                    {m.weekNumber || ''}
                                </td>
                                <td className={getClasses(i)}>
                                    {m.year || ''}
                                </td>
                                </>
                            }
                            {/* Console */}
                            <td className={getClasses(i, m, m.avAssignments.find(a => a.name === assignmentA1)?.user)}>
                                {isEdit ?
                                    <Select className={'hide-arrow text-dark small'}
                                        options={users}
                                        getOptionLabel={u => `${u.name} ${u.lastName}`}
                                        getOptionValue={u => u.id.toString()}
                                        placeholder={assignmentA1}
                                        value={m.avAssignments.find(a => a.name === assignmentA1)?.user}
                                        onChange={u => {
                                            setMeetingsToSave(x => x!.map(_m => _m.id === m.id ? ({
                                                ..._m,
                                                avAssignments: _m.avAssignments.map(a => a.name === m.avAssignments.find(a => a.name === assignmentA1)?.name ? ({
                                                    ...a,
                                                    user: u
                                                }) : a)
                                            }) : _m));
                                        }}
                                        isClearable
                                        isDisabled={!m.date}
                                    />
                                    :
                                    <>{m.avAssignments.find(a => a.name === assignmentA1)?.user ? `${m.avAssignments.find(a => a.name === assignmentA1)!.user!.name} ${m.avAssignments.find(a => a.name === assignmentA1)!.user!.lastName}`: '-'}</>
                                }
                            </td>
                            {/* Zoom/PC */}
                            <td className={getClasses(i, m, m.avAssignments.find(a => a.name === assignmentA2)?.user)}>
                                {isEdit ?
                                    <Select className={'hide-arrow text-dark small'}
                                        options={users}
                                        getOptionLabel={u => `${u.name} ${u.lastName}`}
                                        getOptionValue={u => u.id.toString()}
                                        placeholder={assignmentA2}
                                        value={m.avAssignments.find(a => a.name === assignmentA2)?.user}
                                        onChange={u => {
                                            setMeetingsToSave(x => x!.map(_m => ({
                                                ..._m,
                                                avAssignments: _m.avAssignments.map(a => m.id === _m.id && a.name === m.avAssignments.find(a => a.name === assignmentA2)?.name ? ({
                                                    ...a,
                                                    user: u
                                                }) : a)
                                            })));
                                        }}
                                        isClearable
                                        isDisabled={!m.date}
                                    />
                                    :
                                    <>{m.avAssignments.find(a => a.name === assignmentA2)?.user ? `${m.avAssignments.find(a => a.name === assignmentA2)!.user!.name} ${m.avAssignments.find(a => a.name === assignmentA2)!.user!.lastName}`: '-'}</>
                                }
                            </td>
                            {/* Platform */}
                            <td className={getClasses(i, m, m.avAssignments.find(a => a.name === assignmentA5)?.user)}>
                                {isEdit ?
                                    <Select className={'hide-arrow text-dark small'}
                                        options={users}
                                        getOptionLabel={u => `${u.name} ${u.lastName}`}
                                        getOptionValue={u => u.id.toString()}
                                        placeholder={assignmentA5}
                                        value={m.avAssignments.find(a => a.name === assignmentA5)?.user}
                                        onChange={u => {
                                            setMeetingsToSave(x => x!.map(_m => ({
                                                ..._m,
                                                avAssignments: _m.avAssignments.map(a => m.id === _m.id && a.name === m.avAssignments.find(a => a.name === assignmentA5)?.name ? ({
                                                    ...a,
                                                    user: u
                                                }) : a)
                                            })));
                                        }}
                                        isClearable
                                        isDisabled={!m.date}
                                    />
                                    :
                                    <>{m.avAssignments.find(a => a.name === assignmentA5)?.user ? `${m.avAssignments.find(a => a.name === assignmentA5)!.user!.name} ${m.avAssignments.find(a => a.name === assignmentA5)!.user!.lastName}`: '-'}</>
                                }
                            </td>
                            {/* Mic 1 */}
                            <td className={getClasses(i, m, m.avAssignments.find(a => a.name === assignmentA3)?.user)}>
                                {isEdit ?
                                    <Select className={'hide-arrow text-dark small'}
                                        options={users}
                                        getOptionLabel={u => `${u.name} ${u.lastName}`}
                                        getOptionValue={u => u.id.toString()}
                                        placeholder={assignmentA3}
                                        value={m.avAssignments.find(a => a.name === assignmentA3)?.user}
                                        onChange={u => {
                                            setMeetingsToSave(x => x!.map(_m => ({
                                                ..._m,
                                                avAssignments: _m.avAssignments.map(a => m.id === _m.id && a.name === m.avAssignments.find(a => a.name === assignmentA3)?.name ? ({
                                                    ...a,
                                                    user: u
                                                }) : a)
                                            })));
                                        }}
                                        isClearable
                                        isDisabled={!m.date}
                                    />
                                    :
                                    <>{m.avAssignments.find(a => a.name === assignmentA3)?.user ? `${m.avAssignments.find(a => a.name === assignmentA3)!.user!.name} ${m.avAssignments.find(a => a.name === assignmentA3)!.user!.lastName}`: '-'}</>
                                }
                            </td>
                            {/* Mic 2 */}
                            <td className={getClasses(i, m, m.avAssignments.find(a => a.name === assignmentA4)?.user)}>
                                {isEdit ?
                                    <Select className={'hide-arrow text-dark small'}
                                        options={users}
                                        getOptionLabel={u => `${u.name} ${u.lastName}`}
                                        getOptionValue={u => u.id.toString()}
                                        placeholder={assignmentA4}
                                        value={m.avAssignments.find(a => a.name === assignmentA4)?.user}
                                        onChange={u => {
                                            setMeetingsToSave(x => x!.map(_m => ({
                                                ..._m,
                                                avAssignments: _m.avAssignments.map(a => m.id === _m.id && a.name === m.avAssignments.find(a => a.name === assignmentA4)?.name ? ({
                                                    ...a,
                                                    user: u
                                                }) : a)
                                            })));
                                        }}
                                        isClearable
                                        isDisabled={!m.date}
                                    />
                                    :
                                    <>{m.avAssignments.find(a => a.name === assignmentA4)?.user ? `${m.avAssignments.find(a => a.name === assignmentA4)!.user!.name} ${m.avAssignments.find(a => a.name === assignmentA4)!.user!.lastName}`: '-'}</>
                                }
                            </td>
                            {/* Usher Entrance */}
                            <td className={getClasses(i, m, m.usherAssignments.find(a => a.name === assignmentU1)?.user)}>
                                {isEdit ?
                                    <Select className={'hide-arrow text-dark small'}
                                        options={users}
                                        getOptionLabel={u => `${u.name} ${u.lastName}`}
                                        getOptionValue={u => u.id.toString()}
                                        placeholder={assignmentU1}
                                        value={m.usherAssignments.find(a => a.name === assignmentU1)?.user}
                                        onChange={u => {
                                            setMeetingsToSave(x => x!.map(_m => ({
                                                ..._m,
                                                usherAssignments: _m.usherAssignments.map(a => m.id === _m.id && a.name === m.usherAssignments.find(a => a.name === assignmentU1)?.name ? ({
                                                    ...a,
                                                    user: u
                                                }) : a)
                                            })));
                                        }}
                                        isClearable
                                        isDisabled={!m.date}
                                    />
                                    :
                                    <>{m.usherAssignments.find(a => a.name === assignmentU1)?.user ? `${m.usherAssignments.find(a => a.name === assignmentU1)!.user!.name} ${m.usherAssignments.find(a => a.name === assignmentU1)!.user!.lastName}`: '-'}</>
                                }
                            </td>
                            {/* Usher Auditorium */}
                            <td className={getClasses(i, m, m.usherAssignments.find(a => a.name === assignmentU2)?.user)}>
                                {isEdit ?
                                    <Select className={'hide-arrow text-dark small'}
                                        options={users}
                                        getOptionLabel={u => `${u.name} ${u.lastName}`}
                                        getOptionValue={u => u.id.toString()}
                                        placeholder={assignmentU2}
                                        value={m.usherAssignments.find(a => a.name === assignmentU2)?.user}
                                        onChange={u => {
                                            setMeetingsToSave(x => x!.map(_m => ({
                                                ..._m,
                                                usherAssignments: _m.usherAssignments.map(a => m.id === _m.id && a.name === m.usherAssignments.find(a => a.name === assignmentU2)?.name ? ({
                                                    ...a,
                                                    user: u
                                                }) : a)
                                            })));
                                        }}
                                        isClearable
                                        isDisabled={!m.date}
                                    />
                                    :
                                    <>{m.usherAssignments.find(a => a.name === assignmentU2)?.user ? `${m.usherAssignments.find(a => a.name === assignmentU2)!.user!.name} ${m.usherAssignments.find(a => a.name === assignmentU2)!.user!.lastName}`: '-'}</>
                                }
                            </td>
                            {isEdit &&
                                <td className={getClasses(i)}>
                                    {(!m.sections.length && !m.groupsForCleaning.some(g => !!g)) &&
                                        <button className={'btn btn-danger btn-sm w-100'}
                                            onClick={() => {
                                                setMeetingsToSave(x => x!.filter(_m => _m.id !== m.id));
                                            }}
                                        >
                                            <BsTrashFill className={'mb-1'} />
                                        </button>
                                    }
                                </td>
                            }
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
